<span class="cart-summary-totals__label">Subtotal</span>
<span class="cart-summary-totals__value">{{ checkoutEnabled ? (subtotal | currency) : 'TBD' }}</span>

@if (shouldShowConvenienceFee) {
  <span class="cart-summary-totals__label cart-summary-totals__label--convenience-fee" aria-live="polite">
    <span>
      {{ feeConfig?.label ?? "Convenience Fee" }}{{ convenienceFee != null && feeConfig?.format === 'percent' ? ' ' + (feeConfig?.rate | percent : '0.1-2') : '' }}
    </span>
    @if (feeConfig?.note) {
      <button matIconButton type="button"
        (click)="onClick_showConvenienceFeeNote()"
        [attr.aria-label]="'Information about ' + (feeConfig?.label ?? 'convenience fees')"
        aria-live="off">
        <mat-icon>info</mat-icon>
      </button>
    }
  </span>
  @if (!calculating) {
    <span class="cart-summary-totals__value">{{ convenienceFee | currency }}</span>
  }
  @if (calculating) {
    <mat-spinner class="cart-summary-totals__value" [diameter]="iconSize"></mat-spinner>
  }
}

@if (showDividerBeforeTotal) {
  <mat-divider class="cart-summary-totals__divider"></mat-divider>
}

<span class="cart-summary-totals__label cart-summary-totals__label--total">Total</span>
@if (!calculating) {
  <span class="cart-summary-totals__value cart-summary-totals__value--total">{{ !checkoutEnabled || total == null ? 'TBD' : (total | currency) }}</span>
}
@if (calculating) {
  <mat-spinner class="cart-summary-totals__value" [diameter]="iconSize"></mat-spinner>
}
